import styled from 'styled-components';

export const TabButton = styled.button`
  font-weight: 500;
  background: transparent;
  padding: 16px 1rem;
  width: 100%;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.gray};
  font-family: 'Lato', sans-serif;
  line-height: 24px;
  letter-spacing: 0.51px;
  text-align: left;
  gap: 8px;
`;

export const TabContainer = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: all 0.35s;

  a {
    font-family: 'Lato', sans-serif;
    color: ${({ theme }) => theme.colors.gray};
    font-size: 14px;
    letter-spacing: 0.34px;
    text-decoration: none;
    font-weight: 400;
  }

  p {
    margin: 1em 0;
  }
`;

export const Tab = styled.div`
  position: relative;
  width: 100%;

  input {
    left: 0;
    position: absolute;
    top: 0;
    z-index: -999;
    display: none;
  }

  input:focus + ${TabButton}, ${TabButton}:hover {
    background: ${({ theme }) => theme.colors.white};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray};
  }

  input:checked ~ ${TabContainer} {
    max-height: 30.25em;
  }
  input:checked + ${TabButton} {
    transition: 0.2s all linear;
    background-color: #eff4f8;
  }
  input:checked + ${TabButton} img:nth-of-type(2) {
    transition: 0.2s all linear;
    transform: rotate(180deg);
  }

  input + ${TabButton} img:nth-of-type(2) {
    transition: 0.2s all linear;
    margin-left: auto;
  }
`;

export const TabContent = styled.div`
  padding-left: 1rem;
  display: flex;
  position: relative;
  width: 100%;
  color: ${({ theme }) => theme.colors.gray};
  text-align: left;
  line-height: 24px;
  background-color: #fff;
  font-weight: 500;
  flex-direction: column;
  justify-content: start;

  div a {
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.34px;
    color: #1b1c29;
    justify-self: start;
  }
`;
